module.exports = __webpack_public_path__ + "img/accused.273a9c13.svg";